import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { symbolWinResultDisplay } from "./scatter-result-display";

export function clusterResultDisplay(record: SpinRecord, result: Result) {
    return symbolWinResultDisplay(record, result);
}
